import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { ContactRepository } from '../../../../store/contact-state/contact-state.repository';

interface getContactUpdateDrawerObjectProps {
  store: ContactRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getContactUpdateDrawerObject = ({ store, formObject, toggleVisibility, action }: getContactUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.contact.update.title',
    description: 'settings.contact.update.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.contact.update.update',
        onClick: () => action?.(),
      },
      {
        label: 'settings.contact.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
    onHide: () => {
      store?.reset();
    },
  };
};
